import { render, staticRenderFns } from "./FormReCaptcha.vue?vue&type=template&id=7a471dd2&"
import script from "./FormReCaptcha.vue?vue&type=script&lang=js&"
export * from "./FormReCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./FormReCaptcha.vue?vue&type=style&index=0&id=7a471dd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports